export default __webpack_public_path__ + "static/media/home_product_lister.a754df3e.png";